<div class="container">
  @if(containerId === ''){
    <app-no-data></app-no-data>
  } @else {
    <app-view-details
      [detailsMeta]="containerMeta"
      [detailsData]="containerData"
      (rowActionTriggered)="handleRowAction($event)"
    ></app-view-details>
    <app-activity-log-timeline
    [activityLogData]="containerData?.eventLogList"
    ></app-activity-log-timeline>
  }
</div>
